import axios, { AxiosError } from "axios";
import { logoutURL, loginVerifyURL } from "../utils/auth";
import store from "../redux/store";
import { logout } from "../redux/actions/authActions";

const UNAUTHORIZED = 401;

export interface ApiError {
  results: null;
  error: boolean;
  message: string;
  details?: unknown;
}

export interface ApiResponse<T> {
  results: T;
}

export interface ApiResponsePagination<T> {
  results: T;
  count: number;
  next: null | string;
  previous: null | string;
}

export interface AsyncThunkConfig {
  rejectValue: ApiError;
}

export interface BaseApiState {
  succeeded: boolean;
  loading: boolean;
  error: boolean;
  errorMessage?: string;
  errorDetails?: unknown;
  expiredUserId?: string;
}

export function isAxiosError(error: unknown): error is AxiosError {
  return (error as AxiosError).isAxiosError;
}

const instance = axios.create({
  baseURL: process.env.API_URL ? process.env.API_URL : undefined,
  timeout: 30000,
  withCredentials: true,
});

// handle 401 Unauthorized responses
instance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (
      error.response?.status === UNAUTHORIZED &&
      // prevent dispatching logout() action for a failed logout request
      !error.response?.config.url?.includes(logoutURL) &&
      // prevent dispatching logout() action for a failed login verifying request
      !error.response?.config.url?.includes(loginVerifyURL)
    ) {
      const { dispatch } = store;

      void dispatch(logout());

      return;
    }

    return Promise.reject(error);
  }
);

export default instance;
